import { UploadProgress } from '../UploadProgress';
import { AbstractFileIcon } from '../../../../../../../images/components/AbstractFileIcon';
import { GeorefData } from '../../../../../../../store/uploadStore';
import { CloseIcon, DeleteIcon } from '@traceair/webapp-icons';
import { useHandleUploadCancel } from '../flightUploadProgress/useHandleUploadCancel';
import { ProjectData } from '../../../../types';
import { ScheduledFlight } from '../../../../../../../types';
import { Loader } from '@traceair/tds';

interface Props extends ProjectData {
  georef: GeorefData;
  schedule?: ScheduledFlight;
}

export const GeorefUploadProgress = ({ customer, site, schedule, georef }: Props) => {
  const icon = georef.meta.size === georef.meta.uploadedSize ? <AbstractFileIcon /> : <Loader />;
  const removeIcon = georef.meta.size === georef.meta.uploadedSize ? <DeleteIcon /> : <CloseIcon />;

  const handleRemoveClick = useHandleUploadCancel(false, customer, site, schedule);
  const formatSizeKb = (size: number) => (size / 1024).toFixed(0);
  const progress = (georef.meta.uploadedSize / georef.meta.size) * 100;

  return (
    <>
      <UploadProgress
        icon={icon}
        title={georef.meta.name}
        note={`${formatSizeKb(georef.meta.uploadedSize)} / ${formatSizeKb(georef.meta.size)} KB`}
        removeIcon={removeIcon}
        onRemoveClick={handleRemoveClick}
        progress={progress}
        isWarning={!!georef.meta.error}
        disableCancel={false}
        isDone={progress === 100}
      />
    </>
  );
};
